export const CUSTOM_INCIDENT_ACTION = 'Custom Incident Action';
export const EXTERNAL_SYSTEM = 'External System';
